import { isString, SBaseDisplay } from '@summit/core';

import { EboNameObject } from '../../base-classes/ebo-name-object';
import { AdjustmentType, AdjustmentTypeMapping } from '../employee-adj/adjustment-type.enum';
import { PayrollSource, PayrollSourceMapping } from '../payroll-source.enum';
import { Incentive } from './incentive';
import { IncentiveMethod } from './incentive-method.enum';
import { IncentiveWage } from './incentive-wage';

export class IncentiveWageGroup extends EboNameObject implements SBaseDisplay {
  incentiveID: string;
  incentive: Incentive;
  //Payment Method
  method: IncentiveMethod;
  type: PayrollSource;
  employeeAdjType: AdjustmentType;

  blockWhenFlatRated: boolean;

  description: string;
  wages: IncentiveWage[];

  constructor(jsonData: Partial<IncentiveWageGroup>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.incentive) this.incentive = new Incentive(jsonData.incentive);
      if (isString(this.method)) this.method = parseInt(this.method, 10);
      if (jsonData.wages) this.wages = jsonData.wages.map((item) => new IncentiveWage(item));
      //.sort((e1, e2) => (e1.name > e2.name ? 1 : -1));
    }
    this.wages ??= [];
    this.method ??= IncentiveMethod.EmployeeAdj;
    this.employeeAdjType ??= AdjustmentType.Incentive;
    this.type ??= PayrollSource.Other;
    this.blockWhenFlatRated ??= false;
    //console.log('IncentiveWageGroup', this);
  }

  get typeSummary(): string {
    return this.method == IncentiveMethod.EmployeeAdj
      ? AdjustmentTypeMapping[this.employeeAdjType]
      : PayrollSourceMapping[this.type];
  }
  set typeSummary(value: string) {
    //NOP
  }

  toShortString(): string {
    return this.name;
  }
}
